/**
 * @param {string?} className
 * @returns {string}
 */
export function getOpenInNewIcon(className = ""){
    return `<span class="material-icons ${className} open-in-new-icon">open_in_new</span>`
}